import { Commentaire } from './Commentaire';
import { Correspondance } from './Correspondance';
import { Ecart } from './Ecart';
import { GenericData } from './GenericData';
import { Syncro } from './Syncro';

export class DataComparison {
  idDataComparison?: number;

  correspondance?: Correspondance

  divaltoData?: GenericData;
  rgData?: GenericData;
  bitData?: GenericData;

  ecartRg?: Ecart;
  ecartBit?:Ecart;

  dateFinContrat?: Date;

  isProblemCorrespondancePosteBit?: boolean;

  isProblemCorrespondanceServeurBit?: boolean;

  isProblemCorrespondancePosteRg?: boolean;

  isProblemCorrespondanceServeurRg?: boolean;

  haveEcartBit: boolean = false;

  haveEcartRg?: boolean = false

  haveIncidentAffranchi?: boolean;

  commercial?: string;

  syncro?: Syncro

  commentaires?: Commentaire[];

  haveAllIncidentAffranchi?: boolean
}
